import { render, staticRenderFns } from "./CancellationView.vue?vue&type=template&id=7f24d5ea"
import script from "./CancellationView.vue?vue&type=script&lang=js"
export * from "./CancellationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports